import { createSlice } from "@reduxjs/toolkit";

const countrySlice = createSlice({
  name: "country",
  initialState: {
    countries: [],
    activeCountries: [],
    loading: false,
    error: null,
    total: 0,
    page: 0,
    limit: 5,
    assignResponse: null,
  },
  reducers: {
    // edit country
    updateCountryRequest: (state, action) => {
      state.loading = true;
    },
    updateCountrySuccess: (state, action) => {
      state.loading = false;
    },
    updateCountryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // get store
    fetchCountryRequest: (state) => {
      state.loading = true;
    },
    fetchCountrySuccess: (state, action) => {
      state.loading = false;
      state.countries = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.page = action.payload.page || 0;
      state.limit = action.payload.limit || 5;
    },
    fetchCountryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // create store
    createCountryRequest: (state) => {
      state.loading = true;
    },
    createCountrySuccess: (state) => {
      state.loading = false;
    },
    createCountryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    assignCountriesRequest: (state) => {
      state.loading = true;
      state.assignResponse = null;
    },
    assignCountriesSuccess: (state, action) => {
      state.loading = false;
      state.assignResponse = action.payload;
    },
    assignCountriesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    removeCountryRequest: (state) => {
      state.loading = true;
    },
    removeCountrySuccess: (state, action) => {
      state.loading = false;
      state.assignResponse = action.payload;
    },
    removeCountryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetCountrySuccess: (state) => {
      state.success = false;
    },
    getActiveCountriesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getActiveCountriesSuccess: (state, action) => {
      state.loading = false;
      state.activeCountries = action.payload;
      state.message = "Fetched active countries successfully.";
    },
    getActiveCountriesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCountryRequest,
  fetchCountrySuccess,
  fetchCountryFailure,
  createCountryRequest,
  createCountrySuccess,
  createCountryFailure,
  updateCountryRequest,
  updateCountrySuccess,
  updateCountryFailure,
  resetCountrySuccess,
  assignCountriesRequest,
  assignCountriesSuccess,
  assignCountriesFailure,
  removeCountryRequest,
  removeCountrySuccess,
  removeCountryFailure,
  getActiveCountriesRequest,
  getActiveCountriesSuccess,
  getActiveCountriesFailure,
} = countrySlice.actions;

export default countrySlice.reducer;
